module.exports = __webpack_public_path__ + "img/ic-search-black.c553ca77.svg";